export class Filter {
  filters : any = {};
  sortProperties:any = {};
  textSearch: string;
}
